import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '../../common/RouterHooks';
import SignInLayoutContainer, { SignInLayoutContainerProps } from './containers/SignInLayoutContainer';

const SignInLayout: React.FC<SignInLayoutContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <SignInLayoutContainer {...containerProps} t={t} routeProps={routeProps}>
            {(props) => (<div />)}
        </SignInLayoutContainer>
    );
};

export default SignInLayout;
